import React, {useState, useRef} from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css'
import '../../../css/contactbusiness.scss';
import APICall from '../../actions/apicall';
import Cookies from "js-cookie";
import cancelIcon from '../../../images/cancelIcon.png';
import Submit from '../reusable/Submit';
import Mappings from '../../actions/mappings';
import thumbsImage from '../../../images/thumbsImage.png';
import TitleProgressBar from '../reusable/TitleProgressBar';

function ContactBusinessBottomSheet (props) {
    const [showContactContent, setShowContactContent] = useState(true);
    const [showSelfContent, setShowSelfContent] = useState(false);
    const [showInputContent, setShowInputContent] = useState(false);
    const [percentage, setPercentage] = useState(33);
    const [showContactBusiness, setShowContactBusiness] = useState(true);
    const [selectContactBusinessOptions, setSelectContactBusinessOptions] = useState([]);
    const [selectSelfOptions, setSelectSelfOptions] = useState([]);
    const [nameValue, setNameValue] = useState('');
    const [codeValue, setCodeValue] = useState('+1');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [submitText, setSubmitText] = useState('Submit');
    const [showSelectText, setShowSelectText] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [contactErrorText, setContactErrorText] = useState('');

    const contactBusinessOptions = ['buy', 'lend', 'invest', 'sell_product', 'employment', 'sell_service', 'partial_owner', 'other'];
    const selfOptions = ['employee', 'customer', 'bank', 'venture_pe', 'broker', 'service', 'insurer', 'govt'];

    let accessToken = Cookies.get('access_token') ?? null;
    let userId = Cookies.get('rs11_user_id') ?? 0;

    const handleContactBusinessOptions = () => {
        if (selectContactBusinessOptions.length == 0) {
            setShowSelectText(true);
            return
        }
        (showSelectText) && setShowSelectText(false);
        setShowContactContent(false);
        setShowSelfContent(true);
        setPercentage(66);
        selectContactBusinessOptions.map((item, index)=>{
            window.dataLayer.push({
                'event': 'select_content',
                'contentType': 'contact_reason',
                'contentId': item,
                'businessId': props.business.id
            })
        })
        window.dataLayer.push({
            'event': 'entering_contact_reason',
            'businessId': props.business.id
        });
    }

    const handleSelfOptions = () => {
        if (selectSelfOptions.length == 0) {
            setShowSelectText(true);
            return
        }
        (showSelectText) && setShowSelectText(false);
        setShowSelfContent(false);
        setShowInputContent(true);
        setPercentage(100);
        window.dataLayer.push({
            'event': 'select_content',
            'contentType': 'contact_user_description',
            'contentId': selectSelfOptions,
            'businessId': props.business.id
        })
        window.dataLayer.push({
            'event': 'entering_user_description',
            'businessId': props.business.id
        });
    }

    const handleAPICall = (actions) => {
        setSubmitText('Submitting...');
        let submitted = true;
        (actions == 'close') && (submitted = false);
        if(submitted){
            window.dataLayer.push({
                'event': 'contact_business_submit',
                'businessId': props.business.id
            });
        }
        let data = {
            "business_id": props.business.id,
            "contact_reasons": (selectContactBusinessOptions.length != 0 ? selectContactBusinessOptions.join(", ") : null),
            "relationship": (selectSelfOptions.length != 0 ? selectSelfOptions : null),
            "name": nameValue != '' ? nameValue : null,
            "phone": phoneNumber != '' ? codeValue + ' ' + phoneNumber : null,
            "company": companyName != '' ? companyName : null,
            "submitted": submitted
        }
        let accessToken = Cookies.get('access_token') ?? null;
        APICall.ContactBusiness(data, accessToken, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                setShowContactBusiness(false);
                setSubmitText('Submit');
            }
            else {
                setContactErrorText(response.data.message);
                setShowErrorMessage(true);
                setSubmitText('Submit');
            }
        })
    }

    const handleCloseButtonClick = () => {
        window.dataLayer.push({
            'event': 'contact_business_exit',
            'businessId': props.business.id
        });
        handleAPICall('close');
        props.closeContactBusiness();
    };

    const handleReturnMap = () => {
        props.closeContactBusiness();
    }

    const handleSelfContentBack = () => {
        setShowSelfContent(false);
        setPercentage(33);
        setShowContactContent(true);
    }

    const handleInputContentBack = () => {
        setShowInputContent(false);
        setPercentage(66);
        setShowSelfContent(true);
    }


    return(
        <BottomSheet open={true} onDismiss={handleCloseButtonClick}
            header={
                <div className="transparent-header">
                    <img className='cancel-icon' height='25px' src={cancelIcon} onClick={handleCloseButtonClick} />
                </div>
            }
        >
            {
                (showContactBusiness) ? (
                <div className='contact-business-container'>    
                <TitleProgressBar 
                    text={'Contact Business'} 
                    percentage={percentage} 
                    totalQuestion={3} 
                />      
                    {
                        (showContactContent) && (
                        <div className='contact-business-content'>
                            <p className='name-text'>Why do you want to contact this business?</p>
                            <p className='select-text'>Select all that apply:</p>
                            <div className='contact-options-container'>
                                {
                                    contactBusinessOptions.map((item, i) => (
                                        <button key={item} className={selectContactBusinessOptions.includes(item) ? 'contact-option-button highlight-border' : 'contact-option-button'} onClick={() => setSelectContactBusinessOptions(selectContactBusinessOptions.includes(item)
                                            ? selectContactBusinessOptions.filter(current => current != item)
                                            : [...selectContactBusinessOptions, item]
                                        )}>
                                            <span className={selectContactBusinessOptions.includes(item) ? 'button-text highlight-color' : 'button-text'}>{Mappings[item]}</span>
                                        </button>
                                    ))
                                }
                            </div>
                            {
                                (showSelectText && selectContactBusinessOptions.length == 0) && (
                                <p className='select-one-text'>Please select at least one item.</p>)
                            }
                            <button className='next-button enable' onClick={() => handleContactBusinessOptions()}>
                                <span>Next</span>
                            </button>
                        </div>)
                    }
                    {
                        (showSelfContent) && (
                        <div className='contact-business-content'>
                            <p className='name-text'>Describe Yourself</p>
                            <div className='contact-options-container'>
                                {
                                    selfOptions.map((item, i) => (
                                        <button key={item} className={selectSelfOptions.includes(item) ? 'contact-option-button highlight-border' : 'contact-option-button'} onClick={() => setSelectSelfOptions(item)}>
                                            <span className={selectSelfOptions.includes(item) ? 'button-text highlight-color' : 'button-text'}>{Mappings[item]}</span>
                                        </button>
                                    ))
                                }
                            </div>
                            {
                                (showSelectText && selectSelfOptions.length == 0) && (
                                <p className='select-one-text-2'>Please select at least one item.</p>)
                            }
                            <button className='next-button enable' onClick={() => handleSelfOptions()}>
                                <span>Next</span>
                            </button>
                            <button className='contact-back-button' onClick={() => handleSelfContentBack()}>
                                Back
                            </button>
                        </div>)
                    }
                    {
                        (showInputContent) && (
                        <div className='contact-business-content'>
                            <div className='input-container'>
                                <div className='contact-input'>
                                    <label className='contact-label' for='name'>Name</label>
                                    <input className={'contact-input-field'}
                                        placeholder=''
                                        id='name'
                                        value={nameValue}
                                        onChange={(e) => setNameValue(e.target.value)}
                                    />
                                </div>
                                <div className='contact-input'>
                                    <label className='contact-label' for='phone'>Phone</label>
                                    <div className='phone-number-class'>
                                        <input className={'code-input'}
                                            placeholder=''
                                            id='code-number'
                                            value={codeValue}
                                            onChange={(e) => setCodeValue(e.target.value)}
                                        />
                                        <input className={'contact-input-field'}
                                            placeholder=''
                                            id='phone-number'
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='contact-input'>
                                    <label className='contact-label' for='company'>Company</label>
                                    <input className={'contact-input-field'}
                                        placeholder=''
                                        id='company'
                                        value={companyName}
                                        onChange={(e) => setCompanyName(e.target.value)}
                                    />
                                </div>
                                {
                                (showErrorMessage) && (
                                    <p className='error-text'>{contactErrorText}</p>)
                                }
                            </div>
                            <Submit actionText={submitText} callFunction={handleAPICall} disable={submitText != 'Submit' && true} />
                            <button className='contact-back-button' onClick={() => handleInputContentBack()}>
                                Back
                            </button>
                        </div>)
                    }
                </div>) : (
                <div className='thanks-message'>
                    <img className='thumbs-up-image' src={thumbsImage} />
                    <p className='message-text'>
                        <span className='bold-text'>THANK YOU </span>
                        for your interest in {props.business.fields.business_name} in {props.business.fields.location_address_city}. RS11 is in the process of building relationships with millions of business, and we will contact you as soon as we have reached the owner/manger of the business.</p>
                    <button className='next-button enable' onClick={() => handleReturnMap()}>
                        <span>Return to map</span>
                    </button>
                </div>
                )
            }
        </BottomSheet>
    )
}

export default ContactBusinessBottomSheet;